import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const Drawer = (props) => {
    const { leftPosition, classNames, padding = 'iv-p-30', yPosition = 'iv-top-[44px]', profileMenu = false, layout, } = props;
    return (_jsx("div", { style: { left: leftPosition }, className: clsx('iv-drop-down-box-shadow', 'iv-absolute', layout === 'flex' && 'iv-flex', 'iv-rounded-[10px] iv-bg-grey-0 iv-z-20', 'dark:iv-bg-grey-85', !profileMenu && 'iv-transition-all iv-duration-300', classNames, padding, yPosition), children: props.children }));
};
export default Drawer;
